import { render, staticRenderFns } from "./ComfortSelection.vue?vue&type=template&id=f4d57b9c&scoped=true"
import script from "./ComfortSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComfortSelection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d57b9c",
  null
  
)

export default component.exports